import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllSemestersUserResponse } from 'domain/models';

interface ISemestersState {
  semestersUser: GetAllSemestersUserResponse[];
  loadingSemestersUser: boolean;
}

interface IPayloadSemestersUser
  extends PayloadAction<GetAllSemestersUserResponse[]> {}

const initialState: ISemestersState = {
  semestersUser: [],
  loadingSemestersUser: false,
};

export const SemestersSlice = createSlice({
  name: 'semesters',
  initialState,
  reducers: {
    loadSemestersUser: (state, action: IPayloadSemestersUser) => {
      state.semestersUser = action.payload;
    },
    setLoadingSemestersUser: (state, action: PayloadAction<boolean>) => {
      state.loadingSemestersUser = action.payload;
    },
  },
});

export const { loadSemestersUser, setLoadingSemestersUser } =
  SemestersSlice.actions;

export default SemestersSlice.reducer;
